import React, { useState } from 'react';
import IconButton from 'components/common/IconButton';
import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';

const SectionTableHeader = ({ toggelModal, handleSearch }) => {
  const [keyword, setKeyword] = useState('');

  return (
    <div>
      <FalconCardHeader
        title="Section"
        light
        titleTag="h6"
        endEl={
          <div
            id="orders-actions"
            className="d-flex align-items-center justify-content-between"
          >
            <IconButton
              variant="falcon-default"
              size="md"
              icon="plus"
              transform="shrink-2"
              onClick={toggelModal}
              className="ms-2"
            >
              <span className="d-none d-sm-inline-block ms-1">New</span>
            </IconButton>
            <div className="d-flex align-items-center ms-2">
              <Form.Control
                type="text"
                name="keyword"
                placeholder="Keyword"
                onChange={e => setKeyword(e.target.value)}
              />
              <IconButton
                color="primary"
                className="ms-2"
                size="md"
                icon="search"
                onClick={() => handleSearch(keyword)}
              >
                {/* <FontAwesomeIcon icon={faSearch} /> */}
              </IconButton>
            </div>
          </div>
        }
      />
    </div>
  );
};

SectionTableHeader.propTypes = {
  toggelFilter: PropTypes.func,
  handleSearch: PropTypes.func,
  toggelModal: PropTypes.func
};

export default SectionTableHeader;
